import MultiSelect from "components/common/MultiSelect";
import React, { useEffect } from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { handleClaimFilter } from "../config/claimSlice";
import {
  GetAllPoyer,
  GetPayerInsurance,
} from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import SearchClaimPatient from "./SearchClaimPatient";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import { ArrowRepeat, Chat } from "react-bootstrap-icons";
import { GetAllClaimStatus, GetAllClaimType } from "../config/cliamApi";
import { GetAllIdentifierType } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import classNames from "classnames";

const CliamsListFilter = ({
  watch,
  control,
  clearErrors,
  setValue,
  isSubmitted,
  resetTrigger,
  errors,
}) => {
  const dispatch = useDispatch();
  const { poyerList, payerInsurance } = useSelector(
    (state) => state.eligibilityCheckList,
  );
  const { identifierTypeList } = useSelector((state) => state.eligibilityCheck);
  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch",
  );
  const { userData } = useSelector((state) => state.auth);

  console.log({ branchSetting, allPermissionType });
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  const { claimFilters, claimStatusList, cliamTypeList, claimSubTypeList } =
    useSelector((state) => state.claim);
  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];

  const payer = watch("payer");
  const handleBranch = (selected) => {
    if (!selected) {
      setValue("branch", null);
      dispatch(
        handleClaimFilter({
          check: "branch",
          value: null,
        }),
      );
      return;
    }

    const value = {
      branch_name: selected.label,
      branch_id: selected.value,
      branch_cchino: selected?.cchi,
    };
    setValue("branch", value);
    dispatch(handleClaimFilter({ check: "branch", value }));
    clearErrors("branch", "");
  };
  const handlePayer = (selected) => {
    if (!selected) {
      setValue("payer", null);
      setValue("insurance", null);
      dispatch(handleClaimFilter({ check: "payer", value: null }));
      dispatch(
        handleClaimFilter({
          check: "insurance",
          value: null,
        }),
      );
      return;
    }

    const value = {
      payer_name: selected.label,
      payer_id: selected.value,
    };
    setValue("payer", value);
    dispatch(handleClaimFilter({ check: "payer", value }));
    clearErrors("payer", "");
  };

  const handleInsurance = (selected) => {
    if (!selected) {
      setValue("insurance", null);
      dispatch(
        handleClaimFilter({
          check: "insurance",
          value: null,
        }),
      );
      return;
    }

    const value = {
      insurance_company_name: selected.label,
      insurance_company_id: selected.value,
    };
    setValue("insurance", value);
    dispatch(handleClaimFilter({ check: "insurance", value }));
    clearErrors("insurance", "");
  };

  const handleStartDate = (selected) => {
    setValue("start_date", selected);

    dispatch(
      handleClaimFilter({
        check: "start_date",
        value: selected,
      }),
    );
    clearErrors("start_date", "");
  };
  const handleEndDate = (selected) => {
    setValue("end_date", selected);

    dispatch(
      handleClaimFilter({
        check: "end_date",
        value: selected,
      }),
    );
    clearErrors("end_date", "");
  };
  const handleClaimNumber = (value) => {
    setValue("bundle_request_id", value);
    dispatch(
      handleClaimFilter({
        check: "bundle_request_id",
        value,
      }),
    );
  };
  const handleClaimId = (value) => {
    setValue("claimid", value);
    dispatch(
      handleClaimFilter({
        check: "claimid",
        value,
      }),
    );
  };

  const handleCliamsStatus = (selected) => {
    if (!selected) {
      setValue("cliam_status", null);
      dispatch(
        handleClaimFilter({
          check: "cliam_status",
          value: null,
        }),
      );
      return;
    }

    const value = {
      allstatus_name: selected.label,
      allstatus_code: selected.value,
    };
    setValue("cliam_status", value);
    dispatch(
      handleClaimFilter({
        check: "cliam_status",
        value,
      }),
    );
  };
  const handleClaimSubType = (selected) => {
    if (!selected) {
      setValue("claim_sub_type", null);
      dispatch(
        handleClaimFilter({
          check: "claim_sub_type",
          value: null,
        }),
      );
      return;
    }

    const value = {
      claimsub_types_name: selected.label,
      claimsub_types_id: selected.value,
    };
    setValue("claim_sub_type", value);
    dispatch(
      handleClaimFilter({
        check: "claim_sub_type",
        value,
      }),
    );
  };
  const handleDoctor = (selected) => {
    if (!selected) {
      setValue("doctors", null);
      dispatch(
        handleClaimFilter({
          check: "doctors",
          value: null,
        }),
      );
      return;
    }

    const value = {
      allstatus_name: selected.label,
      allstatus_code: selected.value,
    };
    setValue("doctors", value);
    dispatch(
      handleClaimFilter({
        check: "doctors",
        value,
      }),
    );
  };
  const handleSpecialites = (selected) => {
    if (!selected) {
      setValue("specialities", null);
      dispatch(
        handleClaimFilter({
          check: "specialities",
          value: null,
        }),
      );
      return;
    }

    const value = {
      allstatus_name: selected.label,
      allstatus_code: selected.value,
    };
    setValue("specialities", value);
    dispatch(
      handleClaimFilter({
        check: "specialities",
        value,
      }),
    );
  };
  const handleClaimType = (selected) => {
    if (!selected) {
      setValue("claim_type", null);
      dispatch(
        handleClaimFilter({
          check: "claim_type",
          value: null,
        }),
      );
      return;
    }

    const value = {
      claim_types_name: selected.label,
      claim_types_id: selected.value,
    };
    setValue("claim_type", value);
    dispatch(handleClaimFilter({ check: "claim_type", value }));
    clearErrors("claim_type", "");
  };
  const handleCommunication = (value) => {
    dispatch(
      handleClaimFilter({
        check: "communication",
        value,
      }),
    );
  };
  const handleSecondResponse = (value) => {
    dispatch(
      handleClaimFilter({
        check: "second_response",
        value,
      }),
    );
  };
  const handleIdentityType = (selected) => {
    if (!selected) {
      setValue("identity_type", null);
      dispatch(
        handleClaimFilter({
          check: "identity_type",
          value: null,
        }),
      );
      return;
    }

    const value = {
      ident_type_name: selected.label,
      ident_type_id: selected.value,
    };
    setValue("identity_type", value);
    dispatch(
      handleClaimFilter({
        check: "identity_type",
        value,
      }),
    );
  };

  useEffect(() => {
    if (poyerList?.length === 0) {
      dispatch(GetAllPoyer());
    }
  }, [poyerList]);
  useEffect(() => {
    const selectedPayer = watch("payer");

    if (selectedPayer && selectedPayer.payer_id) {
      dispatch(GetPayerInsurance({ payer_id: selectedPayer.payer_id }));
    } else {
      dispatch(GetPayerInsurance({ payer_id: null })); // optional: to clear insurance
    }
  }, [watch("payer")]);

  useEffect(() => {
    if (payerInsurance?.length === 1) {
      const singleInsurance = payerInsurance[0];
      const value = {
        insurance_company_name: singleInsurance.insurance_company_name,
        insurance_company_id: singleInsurance.insurance_company_id,
      };
      setValue("insurance", value);
      dispatch(handleClaimFilter({ check: "insurance", value }));
    } else {
      setValue("insurance", null);
      dispatch(handleClaimFilter({ check: "insurance", value: null }));
    }
  }, [payerInsurance]);
  useEffect(() => {
    if (payer) {
      const body = { payer_id: payer?.payer_id };
      dispatch(GetPayerInsurance(body));
    }
  }, [payer]);

  useEffect(() => {
    if (claimStatusList?.length === 0) {
      dispatch(GetAllClaimStatus());
    }
    if (cliamTypeList?.length === 0) {
      dispatch(GetAllClaimType());
    }
    if (identifierTypeList?.length === 0) {
      dispatch(GetAllIdentifierType());
    }
  }, []);
  console.log({ errors });
  useEffect(() => {
    setValue("payer", claimFilters?.payer);
    if (claimFilters?.branch) {
      setValue("branch", claimFilters?.branch);
    } else if (selectedBranch) {
      const defaultBranch = {
        branch_id: selectedBranch.value || selectedBranch.branch_id,
        branch_name: selectedBranch.label || selectedBranch.branch_name,
        branch_cchino: selectedBranch.cchi || selectedBranch.branch_cchino,
      };
      setValue("branch", defaultBranch);
      dispatch(handleClaimFilter({ check: "branch", value: defaultBranch }));
    } else {
      setValue("branch", null);
    }
    setValue("insurance", claimFilters?.insurance);
    setValue("start_date", claimFilters?.start_date);
    setValue("end_date", claimFilters?.end_date);
    setValue("ref_number", claimFilters?.ref_number);
    setValue("req_bundle_id", claimFilters?.req_bundle_id);
    setValue("cliam_status", claimFilters?.cliam_status);
    setValue("claim_type", claimFilters?.claim_type);
    setValue("identity_type", claimFilters?.identity_type);
    setValue("claim_sub_type", claimFilters?.claim_sub_type);

    setValue("communication", claimFilters?.communication);
    setValue("second_response", claimFilters?.second_response);
  }, []);

  return (
    <Row>
      {(Number(branchSetting?.list) === 1 &&
        userData?.employee?.syspri_id === 1) ||
      userData?.employee?.syspri_id === 2 ? (
        <Col xs={12} sm={6} md={4} xl={3}>
          <label className="form-label">Branch</label>
          <Controller
            name="branch"
            control={control}
            rules={{ required: "Branch is required" }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                disabled={userData?.employee?.syspri_id === 2}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                errors={errors}
                isMulti={false}
                options={allBranches?.map((item) => ({
                  value: item.branch_id,
                  label: item.branch_name,
                  cchi: item.branch_cchino,
                }))}
                isClearable={true}
                className={classNames({
                  "is-invalid":
                    errors.branch || (isSubmitted && !watch("branch")),
                })}
                value={
                  field.value
                    ? {
                        value: field.value.branch_id,
                        label: field.value.branch_name,
                        cchi: field.value.branch_cchino,
                      }
                    : null
                }
                onChange={(selected) => handleBranch(selected)}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      ) : null}
      <Col xs={12} sm={6} md={4} xl={3}>
        <Form.Group controlId="payer">
          <Form.Label>Payer</Form.Label>
          <Controller
            name="payer"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                errors={errors}
                className={errors?.payer ? "is-invalid" : ""}
                isMulti={false}
                size="sm"
                options={poyerList?.map((poyer) => ({
                  value: poyer.payer_id,
                  label: poyer.payer_name,
                }))}
                isClearable={true}
                placeholder="Choose..."
                value={
                  field.value
                    ? {
                        value: field.value.payer_id,
                        label: field.value.payer_name,
                      }
                    : null
                }
                onChange={(selected) => handlePayer(selected)}
              />
            )}
          />
        </Form.Group>
      </Col>
      <Col xs={12} sm={6} md={4} xl={3}>
        <Form.Group controlId="insurance">
          <Form.Label>Insurance</Form.Label>
          <Controller
            name="insurance"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isClearable={true}
                  isMulti={false}
                  size="sm"
                  errors={errors}
                  options={payerInsurance?.map((poyer) => ({
                    value: poyer.insurance_company_id,
                    label: poyer.insurance_company_name,
                  }))}
                  placeholder="Choose..."
                  className={error ? "is-invalid" : ""}
                  value={
                    field.value
                      ? {
                          value: field.value.insurance_company_id,
                          label: field.value.insurance_company_name,
                        }
                      : null
                  }
                  onChange={(selected) => handleInsurance(selected)}
                />
              </>
            )}
          />
        </Form.Group>
      </Col>
      <SearchClaimPatient resetTrigger={resetTrigger} setValue={setValue} />
      <Col xs={12} sm={6} md={4} xl={3}>
        <BootDatePicker
          name="start_date"
          label="Start Date"
          size="sm"
          control={control}
          selected={watch("start_date")}
          errors={errors}
          onChange={(date) => handleStartDate(date)}
          placeholder="dd/mm/yyyy"
          isRequired={true}
          rules={{
            required: "Start Date is required",
          }}
        />

        {errors?.start_date && (
          <div className="text-danger small mt-1">
            {errors.start_date.message}
          </div>
        )}
      </Col>
      <Col xs={12} sm={6} md={4} xl={3}>
        <BootDatePicker
          name="end_date"
          label="End Date"
          size="sm"
          control={control}
          errors={errors}
          selected={watch("end_date")}
          onChange={(date) => handleEndDate(date)}
          placeholder="dd/mm/yyyy"
          isRequired={true}
          rules={{
            required: "End Date is required",
          }}
        />
      </Col>
      <Col xs={12} sm={6} md={4} xl={3}>
        <Form.Label>Claim Type</Form.Label>
        <Controller
          name="claim_type"
          control={control}
          render={({ field }) => (
            <>
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                errors={errors}
                size="sm"
                options={cliamTypeList?.map((item) => ({
                  value: item?.claim_types_id,
                  label: item?.claim_types_name,
                }))}
                className={errors?.claim_type ? "is-invalid" : ""}
                isClearable={true}
                value={
                  field.value
                    ? {
                        value: field.value.claim_types_id,
                        label: field.value.claim_types_name,
                      }
                    : null
                }
                onChange={(selected) => handleClaimType(selected)}
                placeholder="Choose..."
              />
            </>
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={4} xl={3}>
        <Form.Label>Claim Sub Type</Form.Label>
        <Controller
          name="claim_sub_type"
          control={control}
          render={({ field }) => (
            <>
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                size="sm"
                options={claimSubTypeList?.map((item) => ({
                  value: item?.claimsub_types_id,
                  label: item?.claimsub_types_name,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                        value: field.value.claimsub_types_id,
                        label: field.value.claimsub_types_name,
                      }
                    : null
                }
                onChange={(selected) => handleClaimSubType(selected)}
                placeholder="Choose..."
              />
            </>
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={4} xl={3}>
        <TextInput
          name="bundle_request_id"
          label="Bundle Request Id"
          size="sm"
          onChange={(selected) => handleClaimNumber(selected)}
          control={control}
          placeholder="Bundle Request Id"
        />
      </Col>
      <Col xs={12} sm={6} md={4} xl={3}>
        <TextInput
          name="claimid"
          label="Claim ID"
          size="sm"
          onChange={(selected) => handleClaimId(selected)}
          control={control}
          placeholder="Claim ID"
        />
      </Col>
      <Col xs={12} sm={6} md={4} xl={3}>
        <label className="form-label">Identity Type</label>
        <Controller
          name="identity_type"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={identifierTypeList?.map((item) => ({
                value: item.ident_type_id,
                label: item.ident_type_name,
              }))}
              isClearable={true}
              value={
                field.value
                  ? {
                      value: field.value.ident_type_id,
                      label: field.value.ident_type_name,
                    }
                  : null
              }
              onChange={(selected) => handleIdentityType(selected)}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={4} xl={3}>
        <Form.Label>Claim Status</Form.Label>
        <Controller
          name="cliam_status"
          control={control}
          render={({ field }) => (
            <>
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                size="sm"
                options={claimStatusList?.map((item) => ({
                  value: item?.allstatus_code,
                  label: item?.allstatus_name,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                        value: field.value.allstatus_code,
                        label: field.value.allstatus_name,
                      }
                    : null
                }
                onChange={(selected) => handleCliamsStatus(selected)}
                placeholder="Choose..."
              />
            </>
          )}
        />
      </Col>

      <Col xs={12} sm={6} md={4} xl={3} className="mt-4">
        <Row>
          {/* Second Response */}
          <Col xs={6}>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip
                  style={{
                    "--bs-tooltip-bg": "var(--bs-success)",
                    "--bs-tooltip-color": "var(--bs-white)",
                  }}
                  className="rounded"
                >
                  Second Response
                </Tooltip>
              }
            >
              <div>
                <Controller
                  name="second_response"
                  control={control}
                  render={({ field }) => (
                    <div
                      className={`border d-flex cursor-pointer py-2 justify-content-center gap-2 align-items-center rounded ${
                        field.value
                          ? "badge-subtle-success border-success bg-success-subtle"
                          : "border"
                      }`}
                      onClick={() => {
                        const newValue = !field.value;
                        field.onChange(newValue);
                        handleSecondResponse(newValue);
                      }}
                      style={{ userSelect: "none" }}
                    >
                      <ArrowRepeat className="ms-2" />
                      {field.value ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 512 512"
                        >
                          <path
                            d="M369.16 174.77c7.81 7.81 7.81 20.48 0 28.29L234.99 337.23c-7.81 7.81-20.47 7.81-28.29 0l-63.87-63.88c-7.81-7.81-7.81-20.47 0-28.28 7.81-7.81 20.47-7.81 28.28 0l49.73 49.73L340.86 175.75c7.81-7.81 20.48-7.81 28.29 0zM512 256c0 141.5-114.52 256-256 256S0 397.5 0 256 114.52 0 256 0s256 114.52 256 256zm-40 0c0-119.39-96.62-216-216-216S40 136.61 40 256s96.62 216 216 216 216-96.62 216-216z"
                            fill="#00894f"
                          />
                        </svg>
                      ) : (
                        <svg width="18" height="18" viewBox="0 0 512 512">
                          <circle
                            cx="256"
                            cy="256"
                            r="216"
                            stroke="#bcbcbc"
                            strokeWidth="40"
                            fill="none"
                          />
                        </svg>
                      )}
                    </div>
                  )}
                />
              </div>
            </OverlayTrigger>
          </Col>

          {/* Communication */}
          <Col xs={6}>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip
                  style={{
                    "--bs-tooltip-bg": "var(--bs-warning)",
                    "--bs-tooltip-color": "var(--bs-black)",
                  }}
                  className="rounded"
                >
                  Communication
                </Tooltip>
              }
            >
              <div>
                <Controller
                  name="communication"
                  control={control}
                  render={({ field }) => (
                    <div
                      className={`border d-flex cursor-pointer py-2 justify-content-center gap-2 align-items-center rounded ${
                        field.value
                          ? "badge-subtle-warning border-warning bg-warning-subtle"
                          : "border"
                      }`}
                      onClick={() => {
                        const newValue = !field.value;
                        field.onChange(newValue);
                        handleCommunication(newValue);
                      }}
                      style={{ userSelect: "none" }}
                    >
                      <Chat className="ms-2" />
                      {field.value ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 512 512"
                        >
                          <path
                            d="M369.16 174.77c7.81 7.81 7.81 20.48 0 28.29L234.99 337.23c-7.81 7.81-20.47 7.81-28.29 0l-63.87-63.88c-7.81-7.81-7.81-20.47 0-28.28 7.81-7.81 20.47-7.81 28.28 0l49.73 49.73L340.86 175.75c7.81-7.81 20.48-7.81 28.29 0zM512 256c0 141.5-114.52 256-256 256S0 397.5 0 256 114.52 0 256 0s256 114.52 256 256zm-40 0c0-119.39-96.62-216-216-216S40 136.61 40 256s96.62 216 216 216 216-96.62 216-216z"
                            fill="#f4a100"
                          />
                        </svg>
                      ) : (
                        <svg width="18" height="18" viewBox="0 0 512 512">
                          <circle
                            cx="256"
                            cy="256"
                            r="216"
                            stroke="#bcbcbc"
                            strokeWidth="40"
                            fill="none"
                          />
                        </svg>
                      )}
                    </div>
                  )}
                />
              </div>
            </OverlayTrigger>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CliamsListFilter;
